import classNames from 'classnames';
import EcoIconClose from 'eco-design-micro/icons/eco-icon-close';
import React, { useEffect, useRef } from 'react';
import './index.scss';

export interface EcoDialogProps {
    /**
     * 主题色
     */
    theme?: 'white' | 'black';
    /**
     * 弹窗大小
     */
    size?: 'large' | 'middle' | 'small';
    /**
     * 标题
     */
    title?: string;
    /**
     * 副标题
     */
    subTitle?: string;
    /**
     * 是否开启弹窗
     */
    open: boolean;
    /**
     * 自定义脚部
     */
    footer?: React.ReactNode;
    /**
     * 样式名
     */
    className?: string;
    /**
     * 启用模态框
     */
    isModal?: boolean;
    onClick?: (event: MouseEvent) => void;
    onOk?: () => void;
    onCancel?: () => void;
    /**
     * 内容
     */
    children?: React.ReactNode;
}

/**
 * 基于dialog实现的弹窗
 */
export default function EcoDialog({
    theme = 'white',
    title,
    subTitle,
    open = false,
    isModal = true,
    className,
    size = 'middle',
    onCancel,
    children,
}: EcoDialogProps) {
    const prefixCls = 'eco-dialog';
    const compCls = classNames(`${prefixCls}-root`, {
        [`${className}`]: className,
        [`${prefixCls}-theme-${theme}`]: theme,
        [`${prefixCls}-size-${size}`]: size,
        [`${prefixCls}-no-modal`]: !isModal,
    });
    const refDialog = useRef<HTMLDialogElement>(null);
    // 点击关闭
    const cancelHandle = () => {
        closeDialogHandle();
        if (onCancel) {
            onCancel();
        }
    };
    // 执行关闭
    const closeDialogHandle = () => {
        if (refDialog.current) {
            refDialog.current.close();
        }
    };
    useEffect(() => {
        if (open && refDialog.current && isModal) {
            refDialog.current.showModal();
        } else if (open && refDialog.current) {
            refDialog.current.show();
        }
    }, [open]);

    return (
        <dialog className={compCls} ref={refDialog}>
            <div className={`${prefixCls}-wrap`}>
                <div className={`${prefixCls}-content`}>
                    <div className={`${prefixCls}-header`}>
                        {title && <div className={`${prefixCls}-title`}>{title}</div>}
                        {subTitle && <div className={`${prefixCls}-subTitle`}>{subTitle}</div>}
                    </div>
                    <div className={`${prefixCls}-body`}>{children}</div>
                    <button className={`${prefixCls}-close`} onClick={cancelHandle}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
                            <path
                                d="M16 3.1665C23.3638 3.1665 29.333 9.13669 29.333 16.5005C29.3327 23.8641 23.3636 29.8335 16 29.8335C8.63637 29.8335 2.66726 23.8641 2.66699 16.5005C2.66699 9.13669 8.6362 3.1665 16 3.1665ZM20.707 11.7935C20.3165 11.4029 19.6835 11.4029 19.293 11.7935L16 15.0864L12.707 11.7935C12.3165 11.4029 11.6835 11.4029 11.293 11.7935C10.9027 12.184 10.9025 12.8171 11.293 13.2075L14.5859 16.5005L11.293 19.7935C10.9027 20.184 10.9025 20.8171 11.293 21.2075C11.6834 21.5977 12.3166 21.5977 12.707 21.2075L16 17.9146L19.293 21.2075C19.6834 21.5977 20.3166 21.5977 20.707 21.2075C21.0975 20.8171 21.0973 20.184 20.707 19.7935L17.4141 16.5005L20.707 13.2075C21.0975 12.8171 21.0973 12.184 20.707 11.7935Z"
                                fill="#CFD0D2"
                            />
                        </svg>
                    </button>
                </div>
            </div>
        </dialog>
    );
}
